<template>
  <div :class="$style.container">
    <div
      :class="$style.date"
      v-text="displayDate"
    ></div>
    <div :class="$style.summary">
      <div
        :class="$style.label"
        v-text="$t('crypto.payment.transaction.summary')"
      ></div>
      <div
        :class="$style.value"
        v-text="displayAmount"
      ></div>
    </div>
    <!-- @TODO: доработать после того, как payterra будет готова отдавать информацию по комиссии -->
    <!-- <div :class="$style.commission">
      <div
        :class="$style.label"
        v-text="$t('crypto.payment.transaction.commission')"
      ></div>
      <div
        :class="$style.value"
        v-text="'0.00168681134328 ETH / 4.9921 USDT'"
      ></div>
    </div> -->
    <div :class="$style.hash">
      <div
        :class="$style.label"
        v-text="$t('crypto.payment.transaction.hash')"
      ></div>
      <a
        href="#"
        :class="$style.value"
        v-text="hash"
        @click.prevent="handleCopyHash"
      ></a>
    </div>
    <!-- @TODO: доработать после того, как payterra будет готова отдавать информацию по отправителю -->
    <!-- <div :class="$style.sender">
      <div
        :class="$style.label"
        v-text="$t('crypto.payment.transaction.sender')"
      ></div>
      <a
        href="#"
        :class="$style.value"
        v-text="wallet"
        @click.prevent="handleCopyWallet"
      ></a>
    </div> -->
  </div>
</template>

<script>
import { formatAmount } from 'lib/utils/amount';
import { formatDateToCustomDate } from 'lib/utils/date';
import { copyToClipboard } from 'lib/utils/clipboard';

export default {
  name: 'CryptoTransaction',
  props: {
    transaction: {
      type: Object,
      required: true,
    },
    currency: {
      type: Object,
      required: true,
    },
  },
  computed: {
    displayAmount() {
      return formatAmount(this.transaction.amount, this.currency);
    },
    displayDate() {
      return `${formatDateToCustomDate(this.transaction.createdAt, 'HH:mm:ss')} UTC`;
    },
    hash() {
      return this.transaction.hash;
    },
    // @TODO: доработать после того, как payterra будет готова отдавать информацию по отправителю
    // wallet() {
    //   return this.transaction.wallet;
    // },
  },
  // @TODO: Временные методы, удалить после настройки ссылок для элементов <a>
  methods: {
    handleCopyHash() {
      copyToClipboard(this.hash);

      this.$alert({
        type: 'info',
        title: 'crypto.payment.notify.hash.copied',
      });
    },
    // @TODO: доработать после того, как payterra будет готова отдавать информацию по отправителю
    // handleCopyWallet() {
    //   copyToClipboard(this.wallet);

    //   this.$alert({
    //     type: 'info',
    //     title: 'crypto.payment.notify.wallet.copied',
    //   });
    // },
  },
};
</script>

<style lang="sass" module>
  .container
    display: grid
    grid-gap: 20px
    // @TODO: раскомментировать следующую строку после того, как payterra будет готова отдавать информацию по комиссии и отправителю
    // grid-template-areas: "date date" "summary summary" "commission commission" "hash sender"
    // @TODO: удалить следующую строку после того, как payterra будет готова отдавать информацию по комиссии и отправителю
    grid-template-areas: "date date" "summary summary" "hash hash"
    padding: 20px
    background: var(--color-white)
    box-shadow: 0px 1px 2px rgba(189, 189, 189, 0.5)
    border-radius: 5px

  .date
    +font-type('medium', 12, 18)
    color: var(--color-black-2)
    grid-area: date

  .summary
    grid-area: summary

  // @TODO: раскомментировать после того, как payterra будет готова отдавать информацию по комиссии
  // .commission
  //   grid-area: commission

  .hash
    grid-area: hash
    overflow: hidden

  // @TODO: доработать после того, как payterra будет готова отдавать информацию по отправителю
  // .sender
  //   grid-area: sender
  //   overflow: hidden

  .label
    +font-type('medium', 12, 18)
    color: var(--color-black-2)
    opacity: .5

  .value
    +font-type('medium', 16, 24)
    color: var(--color-black-2)
    overflow: hidden
    white-space: nowrap
    text-overflow: ellipsis

  a.value
    display: block
    position: static
    color: var(--color-blue)
</style>
